import React, { FC } from 'react'
import Box from '@material-ui/core/Box'
import { ReactComponent as CheckCircleOutlineIcon } from 'assets/svg/CheckCircleOutlineIcon.svg'
import { ReactComponent as ErrorOutlineIcon } from 'assets/svg/ErrorOutlineIcon.svg'
import { ReactComponent as InfoIcon } from 'assets/svg/InfoIcon.svg'
import { ReactComponent as WarningOutlineIcon } from 'assets/svg/WarningOutlineIcon.svg'
import { VerificationSeverity } from 'typescript/interfaces/documentVerification'

const severityIcons: Record<VerificationSeverity, typeof InfoIcon> = {
  success: CheckCircleOutlineIcon,
  info: InfoIcon,
  warning: WarningOutlineIcon,
  error: ErrorOutlineIcon,
}

const severityColors: Record<VerificationSeverity, string> = {
  success: 'success.main',
  info: 'secondary.main',
  warning: 'warning.main',
  error: 'error.main',
}

interface IDocumentVerificationIconProps {
  severity: VerificationSeverity
  size?: number | string
}

const DocumentVerificationIcon: FC<IDocumentVerificationIconProps> = ({ severity, size = '1.125em' }) => {
  const Icon = severityIcons[severity]

  return (
    <Box component="span" display="inline-flex" flexShrink={0} color={severityColors[severity]}>
      <Icon width={size} height={size} />
    </Box>
  )
}

export default DocumentVerificationIcon
